'use client'

/**
 * Queue-safe gtag command.
 *
 * Identical mechanics to the official gtag snippet: commands are pushed onto
 * window.dataLayer and gtag.js drains the queue when it loads. This matters
 * because our tag scripts load with strategy="afterInteractive" while client
 * effects (view_item on mount, purchase on the confirmation page) can fire
 * during hydration — before window.gtag exists. Checking
 * `typeof window.gtag === 'function'` at that moment silently drops the event;
 * pushing to dataLayer never does.
 */
export function gtag() {
    if (typeof window === 'undefined') return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(arguments)
}
